<div class="row d-flex flex-column justify-content-center align-items-center vw-100">
  <div class="app-content-container mb-5">
    <div class="d-flex justify-content-between">
      <div class="ml-3">
        {{ getMediaType() === 'pdf' ? mediaInstruction.pdf : mediaInstruction.image }}
      </div>
      <div class="mr-3">
        @if (!isMediaVisible) {
          <svg
            (click)="toggleVisibility()"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        }
        @if (isMediaVisible) {
          <svg
            (click)="toggleVisibility()"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
          </svg>
        }
      </div>
    </div>
    <hr />
    <div class="app-media-container mt-5" [ngClass]="{ visible: isMediaVisible, invisible: !isMediaVisible }">
      <div>
        @switch (getMediaType()) {
          @case ('pdf') {
            <div class="shadow-lg mb-3">
              <pdf-viewer [src]="getFilePath()" [render-text]="true" style="display: block"></pdf-viewer>
            </div>
          }
        }
      </div>
      <app-continue-button (onClick)="saveReadingTime()" [label]="label"></app-continue-button>
    </div>
  </div>
</div>
